import { Input, message, Modal, Select } from "antd";
import React from "react";
import { addSubCategory, updateSubCategory } from "../../utils/api";

const SubModal = ({
  modal,
  setModal,
  newSubCategory,
  setNewSubCategory,
  id,
  getSubCategoriesData,
  update,
  setUpdate,
}) => {
  const [buttonloading, setButtonLoading] = React.useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const createNewSubCategory = async () => {
    if (!newSubCategory.name || !newSubCategory.position)
      return messageApi.error("Please fill all the fields");
    setButtonLoading(true);
    if (!update) {
      const [success, response] = await addSubCategory({
        ...newSubCategory,
        categoryId: id,
      });
      if (success) {
        messageApi.success("Sub Category added successfully");
      }
    } else {
      const [success, response] = await updateSubCategory(
        update,
        newSubCategory
      );
      if (success) {
        messageApi.success("Sub Category updated successfully");
        setUpdate(null);
      }
    }
    getSubCategoriesData();
    setModal(false);
    setNewSubCategory({});
    setButtonLoading(false);
  };
  return (
    <Modal
      confirmLoading={buttonloading}
      onOk={createNewSubCategory}
      title={update ? "Update Sub Category" : "Add New Sub Category"}
      open={modal}
      onCancel={() => setModal(false)}
    >
      <div
        className="col"
        style={{
          marginTop: "10px",
        }}
      >
        <Input
          placeholder="Sub Category Name"
          onChange={(e) =>
            setNewSubCategory({ ...newSubCategory, name: e.target.value })
          }
          value={newSubCategory.name}
        />
        <Input
          placeholder="Sub Category Position"
          onChange={(e) =>
            setNewSubCategory({ ...newSubCategory, position: e.target.value })
          }
          value={newSubCategory.position}
        />
        <Select
          value={newSubCategory.imageType}
          onChange={(e) =>
            setNewSubCategory({
              ...newSubCategory,
              imageType: e,
            })
          }
          placeholder="Select Image Type"
          options={[
            { label: "Vertical", value: "Vertical" },
            { label: "Horizontal", value: "Horizontal" },
            { label: "LongHorizontal", value: "LongHorizontal" },
            { label: "LongVertical", value: "LongVertical" },
            { label: "Promotional", value: "Promotional" },
          ]}
        />
      </div>
    </Modal>
  );
};

export default SubModal;
